<div class="main-content mt-0">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
        <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 0 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-7 col-6">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <div class="flex-grow-1 text-center">
          <a class="btn btn-dark btn-sm btn-new" [routerLink]="['/marketing']">
            Keywords
          </a>
          <a class="btn btn-dark btn-sm btn-reg"> URL Mapping </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/onPage']"
          >
            On-Page
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/internalLinks/add']"
          >
            Internal Links
          </a>
        </div>
      </div>
    </div>

    <div class="row pb-3">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <div class="flex-grow-1 text-center">
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/technicalQa']"
          >
            Technical QA
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/localSeo']"
          >
            Local SEO
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/offPage']"
          >
            Off-Page
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/performance']"
          >
            Performance
          </a>
        </div>
      </div>
    </div>
    <div class="url-mapping-container p-4" *ngIf="!loading">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div class="d-flex align-items-center gap-3">
          <div class="header-icon bg-primary text-white rounded p-2">
            <i class="fas fa-sitemap fa-lg"></i>
          </div>
          <div class="pl-2">
            <h2 class="h4 mb-0 fw-bold">URL MAPPING</h2>
            <!-- <p class="text-muted mb-0 small">
              Map search intents to the most appropriate URLs. Define primary
              ownership, supporting pages, and resolve architectural gaps.
            </p> -->
          </div>
        </div>
        <div class="d-flex gap-2">
          <!-- <button class="btn btn-outline-secondary btn-sm p-1 btn-header">
            <i class="fas fa-play-circle me-1"></i> How it works
          </button> -->
          <button class="btn btn-outline-secondary btn-sm p-1 btn-header">
            <i class="fas fa-download me-1"></i> Export Report
          </button>
          <!-- <button class="btn btn-sm btn-add p-1 btn-header">
            <i class="fas fa-plus me-1"></i> Add Mapping Review
          </button> -->
        </div>
      </div>

      <!-- Main Layout -->
      <div class="row">
        <div class="col-12">
          <!-- Filters -->

          <div class="row mb-0 px-3">
            <div class="col-3">
              <label class="text-dark" for="urlMapping"
                ><strong>Filters</strong></label
              >
            </div>
            <div class="col-9 d-flex justify-content-end mt-2 pr-0">
              <button
                class="btn btn-outline-secondary btn-sm btn-filter"
                (click)="onFilterChange()"
              >
                Find
              </button>
            </div>

            <!-- Location filter (dynamic) -->
            <div class="col-2 filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Location</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
                [(ngModel)]="pendingLocation"
              >
                <option *ngFor="let loc of locations" [value]="loc.value">
                  {{ loc.label }}
                </option>
              </select>
            </div>

            <!-- Universe filter (dynamic) -->
            <div class="col-2 filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Universe</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
                [(ngModel)]="pendingUniverse"
              >
                <option value="">All Universes</option>
                <option *ngFor="let uni of universes" [value]="uni.value">
                  {{ uni.label }}
                </option>
              </select>
            </div>

            <!-- Category filter (dynamic) -->
            <div class="col-2 filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Category</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
                [(ngModel)]="pendingCategory"
              >
                <option value="">All Categories</option>
                <option *ngFor="let cat of categories" [value]="cat.value">
                  {{ cat.label }}
                </option>
              </select>
            </div>

            <div class="col-2 filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Keyword Status</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
              >
                <option>All</option>
              </select>
            </div>

            <div class="col-2 filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Mapping Status</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
              >
                <option>All</option>
              </select>
            </div>

            <div class="col-2 filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Architecture Fit</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
              >
                <option>All</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="row">
        <div class="col-12"> -->
      <!-- Statistics -->
      <div class="row">
        <div class="col-12">
          <div
            class="row m-0 align-items-stretch flex-nowrap custom-scroll-x p-0 gap-3"
          >
            <!-- Stat 1  style="min-width: 250px"-->
            <div class="col p-0 pr-1 d-flex">
              <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                <div class="card-body px-1 py-1 d-flex">
                  <div class="stat-icon-filled bg-blue me-3">
                    <i class="material-icons">sell</i>
                  </div>
                  <div class="space-cards">
                    <div
                      class="text-uppercase fw-bold text-dark mb-1"
                      style="font-size: 0.65rem; letter-spacing: 0.5px"
                    >
                      <strong>Mapped Keywords</strong>
                    </div>
                    <h3 class="mb-1 fw-bold text-dark">
                      {{ stats.mappedKeywords.value }}
                    </h3>
                    <div
                      class="small fw-medium"
                      [ngClass]="
                        stats.mappedKeywords.up ? 'text-success' : 'text-danger'
                      "
                    >
                      <span
                        class="material-icons align-middle"
                        style="font-size: 14px"
                      >
                        {{
                          stats.mappedKeywords.up
                            ? "arrow_upward"
                            : "arrow_downward"
                        }}
                      </span>
                      {{ stats.mappedKeywords.trend }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Stat 2 -->
            <div class="col p-0 pr-1 d-flex">
              <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                <div class="card-body px-1 py-1 d-flex">
                  <div class="stat-icon-filled bg-green me-3">
                    <i class="material-icons">search</i>
                  </div>
                  <div class="space-cards">
                    <div
                      class="text-uppercase fw-bold text-dark mb-1"
                      style="font-size: 0.65rem; letter-spacing: 0.5px"
                    >
                      <strong>Mapped Pages</strong>
                    </div>
                    <h3 class="mb-1 fw-bold text-dark">
                      {{ stats.mappedPages.value }}
                    </h3>
                    <div class="small fw-medium text-success">
                      <span
                        class="material-icons align-middle"
                        style="font-size: 14px"
                        >arrow_upward</span
                      >
                      {{ stats.mappedPages.trend }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Stat 3 -->
            <div class="col p-0 pr-1 d-flex">
              <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                <div class="card-body px-1 py-1 d-flex">
                  <div class="stat-icon-filled bg-orange me-3">
                    <i class="material-icons">find_replace</i>
                  </div>
                  <div class="space-cards">
                    <div
                      class="text-uppercase fw-bold text-dark mb-1"
                      style="font-size: 0.65rem; letter-spacing: 0.5px"
                    >
                      <strong>Unmapped High-Value</strong>
                    </div>
                    <h3 class="mb-1 fw-bold text-dark">
                      {{ stats.unmappedHighValue.value }}
                    </h3>
                    <div class="small fw-medium text-danger">
                      <span
                        class="material-icons align-middle"
                        style="font-size: 14px"
                        >arrow_downward</span
                      >
                      {{ stats.unmappedHighValue.trend }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Stat 4 -->
            <div class="col p-0 pr-1 d-flex">
              <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                <div class="card-body px-1 py-1 d-flex">
                  <div class="stat-icon-filled bg-red me-3">
                    <i class="material-icons">gps_off</i>
                  </div>
                  <div class="space-cards">
                    <div
                      class="text-uppercase fw-bold text-dark mb-1"
                      style="font-size: 0.65rem; letter-spacing: 0.5px"
                    >
                      <strong>Cannibalization Issues</strong>
                    </div>
                    <h3 class="mb-1 fw-bold text-dark">
                      {{ stats.cannibalizationIssues.value }}
                    </h3>
                    <div class="small fw-medium text-danger">
                      <span
                        class="material-icons align-middle"
                        style="font-size: 14px"
                        >arrow_downward</span
                      >
                      {{ stats.cannibalizationIssues.trend }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Stat 5 -->
            <div class="col p-0 pr-1 d-flex">
              <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                <div class="card-body px-1 py-1 d-flex">
                  <div class="stat-icon-filled bg-purple me-3">
                    <i class="material-icons">plagiarism</i>
                  </div>
                  <div class="space-cards">
                    <div
                      class="text-uppercase fw-bold text-dark mb-1"
                      style="font-size: 0.65rem; letter-spacing: 0.5px"
                    >
                      <strong>Mapping Gaps</strong>
                    </div>
                    <h3 class="mb-1 fw-bold text-dark">
                      {{ stats.mappingGaps.value }}
                    </h3>
                    <div class="small fw-medium text-muted">
                      {{ stats.mappingGaps.text }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- </div> -->
          </div>
        </div>
      </div>
      <!-- </div>
      </div> -->

      <div class="row">
        <div class="col-12 d-flex">
          <div class="card shadow-sm mt-0 flex-grow-1">
            <!-- KEYWORD PORTFOLIO OVERVIEW header -->
            <!-- <div
              class="portfolio-header d-flex align-items-center justify-content-between px-3 py-2"
            >
              <span class="portfolio-title"
                ><strong>KEYWORD PORTFOLIO OVERVIEW</strong></span
              >
            </div> -->
            <div class="card-header bg-white border-bottom-0 pb-0">
              <h4 class="fw-bold fs-6 mb-3">
                <strong>KEYWORD PORTFOLIO OVERVIEW</strong>
                <i class="fas fa-info-circle text-muted ms-1 small pl-1"></i>
              </h4>
              <div class="card-body p-0">
                <div class="table-responsive">
                  <table class="table table-hover align-middle mb-0 text-sm">
                    <thead class="bg-light small text-uppercase">
                      <tr>
                        <th class="ps-3 kw-url-mapping-header">
                          <strong>Keyword</strong
                          ><i
                            class="fas fa-arrows-alt-v ms-1 text-muted small pl-1"
                          ></i>
                        </th>
                        <th class="kw-url-mapping-header">
                          <strong>Current Pos.</strong>
                        </th>
                        <th class="kw-url-mapping-header">
                          <strong>Previous</strong>
                        </th>
                        <th class="kw-url-mapping-header">
                          <strong>Change</strong>
                        </th>
                        <th class="kw-url-mapping-header">
                          <strong>Overall Trend</strong>
                        </th>
                        <th class="kw-url-mapping-header">
                          <strong>Opp. Rank</strong>
                        </th>
                        <th class="kw-url-mapping-header">
                          <strong>Volume</strong>
                        </th>
                        <th class="kw-url-mapping-header">
                          <strong>Status</strong>
                        </th>
                        <th class="kw-url-mapping-header">
                          <strong>Last Check</strong>
                        </th>
                        <th
                          class="kw-url-mapping-header actions-col-header"
                          [class.actions-col-expanded]="actionsExpanded"
                        >
                          <button
                            class="btn btn-link p-0 actions-toggle-btn px-2"
                            (click)="actionsExpanded = !actionsExpanded"
                            [title]="
                              actionsExpanded
                                ? 'Collapse actions'
                                : 'Expand actions'
                            "
                          >
                            <i class="fas fa-ellipsis-v"></i>
                          </button>
                          <span
                            class="actions-col-label pl-2"
                            [class.visible]="actionsExpanded"
                            >Actions</span
                          >
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container
                        *ngIf="
                          selectedLocation &&
                          selectedUniverse &&
                          filteredData.length > 0
                        "
                      >
                        <ng-container *ngFor="let item of filteredData">
                          <tr
                            *ngFor="
                              let kw of getKeywords(item);
                              let kwIndex = index
                            "
                          >
                            <!-- Keyword -->
                            <td class="ps-3 text-nowrap">
                              <a
                                *ngIf="kw.url"
                                [href]="kw.url"
                                target="_blank"
                                class="kw-link"
                                [ngClass]="{
                                  'text-muted text-decoration-line-through':
                                    kw.status === 'disabled',
                                  'text-warning': kw.status === 'paused',
                                }"
                              >
                                {{ kw.value }}
                                <i
                                  class="fas fa-external-link-alt fa-xs ms-1"
                                ></i>
                              </a>
                              <span
                                *ngIf="!kw.url"
                                [ngClass]="{
                                  'text-muted text-decoration-line-through':
                                    kw.status === 'disabled',
                                  'text-warning': kw.status === 'paused',
                                }"
                                >{{ kw.value }}</span
                              >
                            </td>

                            <!-- Current Pos. -->
                            <td class="text-center">
                              <span
                                *ngIf="
                                  kw.currentPos !== undefined &&
                                  kw.currentPos !== null
                                "
                                >#{{ kw.currentPos }}</span
                              >
                              <span
                                *ngIf="
                                  kw.currentPos === undefined ||
                                  kw.currentPos === null
                                "
                                >—</span
                              >
                            </td>

                            <!-- Prev. Pos. -->
                            <td class="text-center">
                              <span
                                *ngIf="
                                  kw.prevPos !== undefined &&
                                  kw.prevPos !== null
                                "
                                >#{{ kw.prevPos }}</span
                              >
                              <span
                                *ngIf="
                                  kw.prevPos === undefined ||
                                  kw.prevPos === null
                                "
                                >—</span
                              >
                            </td>

                            <!-- Change -->
                            <td class="text-center">
                              <ng-container
                                *ngIf="
                                  kw.change !== undefined && kw.change !== null;
                                  else noChange
                                "
                              >
                                <span
                                  *ngIf="kw.change > 0"
                                  class="text-success fw-semibold"
                                >
                                  <i class="fas fa-caret-up"></i>
                                  {{ kw.change }}
                                </span>
                                <span
                                  *ngIf="kw.change < 0"
                                  class="text-danger fw-semibold"
                                >
                                  <i class="fas fa-caret-down"></i>
                                  {{ kw.change * -1 }}
                                </span>
                                <span *ngIf="kw.change === 0" class="text-muted"
                                  >—</span
                                >
                              </ng-container>
                              <ng-template #noChange
                                ><span class="text-muted">—</span></ng-template
                              >
                            </td>

                            <!-- Overall Trend -->
                            <td class="text-center">
                              <ng-container [ngSwitch]="kw.trend">
                                <span
                                  *ngSwitchCase="'improving'"
                                  class="trend-label trend-improving"
                                >
                                  <i class="fas fa-chart-line"></i> Improving
                                </span>
                                <span
                                  *ngSwitchCase="'declining'"
                                  class="trend-label trend-declining"
                                >
                                  <i
                                    class="fas fa-chart-line fa-flip-vertical"
                                  ></i>
                                  Declining
                                </span>
                                <span
                                  *ngSwitchCase="'stable'"
                                  class="trend-label trend-stable"
                                >
                                  <i class="fas fa-minus"></i> Stable
                                </span>
                                <span *ngSwitchDefault class="text-muted"
                                  >—</span
                                >
                              </ng-container>
                            </td>

                            <!-- Opp. Rank -->
                            <td class="text-center">
                              <span *ngIf="kw.oppRank">{{ kw.oppRank }}</span>
                              <span *ngIf="!kw.oppRank" class="text-muted"
                                >—</span
                              >
                            </td>

                            <!-- Search Volume -->
                            <td class="text-center">
                              <span
                                *ngIf="
                                  kw.searchVolume !== undefined &&
                                  kw.searchVolume !== null
                                "
                                >{{ kw.searchVolume }}</span
                              >
                              <span
                                *ngIf="
                                  kw.searchVolume === undefined ||
                                  kw.searchVolume === null
                                "
                                class="text-muted"
                                >—</span
                              >
                            </td>

                            <!-- Status -->
                            <td class="text-center">
                              <span
                                class="badge"
                                [ngClass]="{
                                  'badge-success': kw.status === 'active',
                                  'badge-warning': kw.status === 'paused',
                                  'badge-secondary': kw.status === 'disabled',
                                  'badge-info': kw.status === 'banked',
                                  'badge-danger': kw.status === 'review',
                                }"
                              >
                                {{ kw.status | uppercase }}
                              </span>
                            </td>

                            <!-- Last Check -->
                            <td class="text-center text-nowrap">
                              <ng-container
                                *ngIf="kw.lastCheck; else noLastCheck"
                              >
                                <span class="last-check-date">{{
                                  kw.lastCheck | date: "MMM d, yyyy"
                                }}</span>
                                <span
                                  class="last-check-dot ms-1 ml-1"
                                  [ngClass]="{
                                    'dot-fresh':
                                      getLastCheckStatus(kw.lastCheck) ===
                                      'fresh',
                                    'dot-due':
                                      getLastCheckStatus(kw.lastCheck) ===
                                      'due',
                                  }"
                                ></span>
                                <span
                                  class="ms-1 pl-1"
                                  style="font-size: 0.8rem"
                                  [ngClass]="{
                                    'text-fresh':
                                      getLastCheckStatus(kw.lastCheck) ===
                                      'fresh',
                                    'text-due':
                                      getLastCheckStatus(kw.lastCheck) ===
                                      'due',
                                  }"
                                  >{{
                                    getLastCheckStatus(kw.lastCheck) === "fresh"
                                      ? "Fresh"
                                      : "Due"
                                  }}</span
                                >
                              </ng-container>
                              <ng-template #noLastCheck
                                ><span class="text-muted">—</span></ng-template
                              >
                            </td>

                            <!-- Actions -->
                            <td
                              class="text-center text-nowrap actions-col-cell"
                              [class.actions-col-expanded]="actionsExpanded"
                            >
                              <!-- <a
                                *ngIf="kwIndex == 0"
                                class="btn btn-link text-info btn-sm p-0 mx-1"
                                [routerLink]="[
                                  '/marketing/seo/offPageCampaigns/view',
                                  item._id,
                                ]"
                                title="View"
                              >
                                <i class="fas fa-eye"></i>
                              </a> -->

                              <!-- Activar -->
                              <button
                                *ngIf="kw.status !== 'active'"
                                class="btn btn-link text-success btn-sm p-0 mx-1"
                                (click)="
                                  changeKeywordStatus(item, kw, 'active')
                                "
                                title="Activar"
                              >
                                <i class="fas fa-play"></i>
                              </button>

                              <!-- Pausar -->
                              <button
                                *ngIf="kw.status === 'active'"
                                class="btn btn-link text-warning btn-sm p-0 mx-1"
                                (click)="
                                  changeKeywordStatus(item, kw, 'paused')
                                "
                                title="Pausar"
                              >
                                <i class="fas fa-pause"></i>
                              </button>

                              <!-- Deshabilitar -->
                              <button
                                *ngIf="kw.status !== 'disabled'"
                                class="btn btn-link text-danger btn-sm p-0 mx-1"
                                (click)="
                                  changeKeywordStatus(item, kw, 'disabled')
                                "
                                title="Deshabilitar"
                              >
                                <i class="fas fa-times"></i>
                              </button>

                              <!-- Eliminar -->
                              <button
                                class="btn btn-link text-danger btn-sm p-0 mx-1"
                                (click)="deleteKeyword(item, kw)"
                                title="Eliminar permanentemente"
                              >
                                <i class="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        </ng-container>
                      </ng-container>
                      <tr
                        *ngIf="
                          hasSearched &&
                          selectedLocation &&
                          selectedUniverse &&
                          filteredData.length === 0
                        "
                      >
                        <td colspan="10" class="text-center py-4 text-muted">
                          No data found for the selected scope.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div
            class="row m-auto"
            *ngIf="!selectedLocation || !selectedUniverse"
          >
            <div class="col-12 text-center">
              <div class="alert alert-info shadow-sm">
                <i class="fas fa-info-circle me-2"></i>
                Please select both a location and a universe to see the
                campaigns.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 d-flex">
          <!-- Left Column (Table) -->

          <div class="card shadow-sm mb-4 mt-0 flex-grow-1">
            <div class="card-header bg-white border-bottom-0 pb-0 px-0">
              <h4 class="fw-bold fs-6 mb-3 pl-3">
                <strong>KEYWORD-TO-URL MAP</strong>
                <i class="fas fa-info-circle text-muted ms-1 small pl-1"></i>
              </h4>

              <ul
                class="nav nav-tabs nav-tabs-custom flex-nowrap custom-scroll-x px-0 pb-4 ul-tabs-custom"
              >
                <li class="nav-item">
                  <a class="nav-link active fw-bold" href="javascript:void(0)"
                    ><strong>All Mappings</strong>
                    <span
                      class="badge bg-light border border-info text-dark ms-1"
                      >742</span
                    ></a
                  >
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="javascript:void(0)"
                    ><strong>Primary URLs</strong>
                    <span
                      class="badge bg-light border border-primary text-primary ms-1"
                      >312</span
                    ></a
                  >
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="javascript:void(0)"
                    ><strong>Supporting URLs</strong>
                    <span
                      class="badge bg-light border border-info text-info ms-1"
                      >430</span
                    ></a
                  >
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="javascript:void(0)"
                    ><strong>Unmapped</strong>
                    <span
                      class="badge bg-light border border-secondary text-secondary ms-1"
                      >38</span
                    ></a
                  >
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="javascript:void(0)"
                    ><strong>Needs Review</strong>
                    <span
                      class="badge bg-light border border-warning text-warning ms-1"
                      >27</span
                    ></a
                  >
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="javascript:void(0)"
                    ><strong>Cannibalization</strong>
                    <span
                      class="badge bg-light border border-danger text-danger ms-1"
                      >16</span
                    ></a
                  >
                </li>
              </ul>
            </div>
            <div class="card-body p-0">
              <div class="table-responsive">
                <table class="table table-hover align-middle mb-0 text-sm">
                  <thead class="bg-light small text-uppercase">
                    <tr>
                      <th class="ps-3 kw-url-mapping-header">
                        <strong>KEYWORD / CLUSTER</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>INTENT</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>URL</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>ROLE</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>ARCHITECTURE FIT</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>SEMANTIC</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>INTENT SUPPORT</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>STATUS</strong>
                      </th>
                      <th class="pe-3 text-end kw-url-mapping-header">
                        <strong>ACTION</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let m of mappings"
                      [class.table-active]="
                        m.keyword === selectedMapping.keyword
                      "
                      (click)="selectMapping(m)"
                      style="cursor: pointer"
                    >
                      <td class="ps-3 fw-medium text-primary">
                        {{ m.keyword }}
                      </td>
                      <td>{{ m.searchIntent }}</td>
                      <td>{{ m.primaryUrl }}</td>
                      <td>
                        <span
                          [ngClass]="
                            m.urlRole === 'Primary'
                              ? 'text-success fw-medium'
                              : m.urlRole === 'Supporting'
                                ? 'text-primary fw-medium'
                                : ''
                          "
                          >{{ m.urlRole }}</span
                        >
                      </td>
                      <td>
                        <span
                          class="badge rounded-pill text-transform-none badge-arch"
                          [ngClass]="{
                            'bg-success-light text-success':
                              m.architectureFit === 'Perfect Fit',
                            'bg-warning-light text-warning':
                              m.architectureFit === 'Mappable' ||
                              m.architectureFit === 'Needs Optimization',
                            'bg-danger-light text-danger':
                              m.architectureFit === 'Needs New URL',
                          }"
                        >
                          {{ m.architectureFit }}
                        </span>
                      </td>
                      <td>
                        <span
                          [ngClass]="
                            m.semanticCoverage === 'Strong'
                              ? 'text-success fw-medium'
                              : m.semanticCoverage === 'Moderate'
                                ? 'text-warning fw-medium'
                                : ''
                          "
                          >{{ m.semanticCoverage }}</span
                        >
                      </td>
                      <td>
                        <span
                          [ngClass]="
                            m.explicitIntentSupport === 'Strong'
                              ? 'text-success fw-medium'
                              : m.explicitIntentSupport === 'Weak'
                                ? 'text-danger fw-medium'
                                : m.explicitIntentSupport === 'Moderate'
                                  ? 'text-warning fw-medium'
                                  : ''
                          "
                          >{{ m.explicitIntentSupport }}</span
                        >
                      </td>
                      <td>
                        <span
                          class="badge rounded-pill"
                          [ngClass]="{
                            'bg-success-light text-success':
                              m.mappingStatus === 'Mapped',
                            'bg-warning-light text-warning':
                              m.mappingStatus === 'Needs Review',
                            'bg-danger-light text-danger':
                              m.mappingStatus === 'Unmapped',
                          }"
                        >
                          {{ m.mappingStatus }}
                        </span>
                      </td>
                      <td class="pe-3 text-end">
                        <button
                          (click)="selectMapping(m); $event.stopPropagation()"
                          class="btn btn-sm btn-link border border-primary text-primary text-decoration-none btn-review"
                        >
                          Review
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- <div
                class="d-flex justify-content-between align-items-center p-3 border-top bg-light"
              >
                <span class="small text-muted"
                  >Showing 1 to 8 of 742 results</span
                >
                <div class="d-flex gap-1">
                  <button class="btn btn-sm btn-outline-secondary px-2">
                    <i class="fas fa-chevron-left"></i>
                  </button>
                  <button
                    class="btn btn-sm btn-dark px-2"
                    style="background: transparent; border: 0"
                  >
                    1
                  </button>
                  <button class="btn btn-sm btn-outline-secondary px-2">
                    2
                  </button>
                  <button class="btn btn-sm btn-outline-secondary px-2">
                    3
                  </button>
                  <span class="px-2">...</span>
                  <button class="btn btn-sm btn-outline-secondary px-2">
                    93
                  </button>
                  <button class="btn btn-sm btn-outline-secondary px-2">
                    <i class="fas fa-chevron-right"></i>
                  </button>
                </div>
                <select class="form-select form-select-sm w-auto">
                  <option>10 / page</option>
                </select>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-6 d-flex">
          <div class="card shadow-sm mb-0 mt-0 flex-grow-1">
            <div
              class="card-header bg-white border-bottom-0 d-flex justify-content-between align-items-center pb-0 pt-3 p-2"
            >
              <h4 class="fw-bold text-uppercase mb-0">
                <strong>SELECTED MAPPING REVIEW</strong>
              </h4>
              <!-- <button class="btn btn-sm btn-link text-muted">
                <i class="fas fa-times"></i>
              </button> -->
            </div>
            <div class="card-body pt-2 p-2">
              <p class="small text-uppercase mb-1 font-size10">
                <strong>KEYWORD / CLUSTER</strong>
              </p>
              <div class="d-flex align-items-center mb-2">
                <h5 class="text-dark mb-0 me-2">
                  {{ selectedMapping.keyword }}
                </h5>
                <span
                  class="badge bg-success-light text-success text-transformNone"
                  >{{ selectedMapping.status }}</span
                >
              </div>
              <div class="d-flex gap-1 mb-4">
                <span
                  class="badge bg-primary-light text-primary border text-transformNone"
                  *ngFor="let tag of selectedMapping.tags"
                  >{{ tag }}</span
                >
              </div>

              <p class="small text-uppercase mb-1 font-size10">
                <strong>PRIMARY URL CANDIDATE</strong>
              </p>
              <h5 class="text-primary mb-4">
                <a href="#"
                  >{{ selectedMapping.primaryUrlCandidate }}
                  <i class="fas fa-external-link-alt small"></i
                ></a>
              </h5>

              <div class="table-responsive custom-scroll-x">
                <table
                  class="table table-sm table-borderless small mb-4 border-bottom border-info"
                >
                  <tbody>
                    <tr>
                      <td class="text-dark w-50">Architectural Fit</td>
                      <td class="text-end">
                        <span
                          class="badge bg-warning-light text-warning text-transformNone"
                          >{{ selectedMapping.architecturalFit }}</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark w-50">Semantic Coverage</td>
                      <td class="text-end">
                        <span
                          class="badge bg-success-light text-success text-transformNone"
                          >{{ selectedMapping.semanticCoverage }}</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark w-50">Explicit Intent Support</td>
                      <td class="text-end">
                        <span
                          class="badge bg-danger-light text-danger text-transformNone"
                          >{{ selectedMapping.explicitIntentSupport }}</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark w-50">Cannibalization Risk</td>
                      <td class="text-end">
                        <span
                          class="badge bg-success-light text-success text-transformNone"
                          >{{ selectedMapping.cannibalizationRisk }}</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark w-50">Technical Eligibility</td>
                      <td class="text-end">
                        <span
                          class="badge bg-success-light text-success text-transformNone"
                          >{{ selectedMapping.technicalEligibility }}</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark w-50">Content Depth</td>
                      <td class="text-end">
                        <span
                          class="badge bg-warning-light text-warning text-transformNone"
                          >{{ selectedMapping.contentDepth }}</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark w-50">Current Ranking URL</td>
                      <td class="text-end">
                        <a href="#" class="text-decoration-none">{{
                          selectedMapping.currentRankingUrl
                        }}</a>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark w-50">Mapping Divergence</td>
                      <td class="text-end">
                        <span
                          class="badge bg-danger-light text-danger text-transformNone"
                          >{{ selectedMapping.mappingDivergence }}</span
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="bg-light p-2 rounded">
                <h5 class="small fw-bold text-uppercase mb-2 ai-rationale">
                  AI RATIONALE
                </h5>
                <p class="small text-muted mb-0 lh-sm">
                  {{ selectedMapping.aiRationale }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-6 d-flex pl-0">
          <!-- Signals -->
          <div class="card shadow-sm mt-0 mb-0 flex-grow-1">
            <div
              class="card-header bg-white border-bottom-0 pb-0 d-flex justify-content-between align-items-center"
            >
              <h4 class="fw-bold text-uppercase small mb-0">
                <strong>SIGNALS</strong>
                <i class="fas fa-info-circle text-muted ms-1"></i>
              </h4>
              <a href="#" class="small text-decoration-none text-primary"
                >View all signals <i class="fas fa-arrow-right"></i
              ></a>
            </div>
            <div class="card-body p-2 mt-3 custom-scroll-x">
              <table class="table table-sm table-borderless small mb-0">
                <thead class="text-uppercase">
                  <tr>
                    <th class="ps-3 header-signals-activity">TITLE</th>
                    <th class="header-signals-activity">TO</th>
                    <th class="header-signals-activity">STATUS</th>
                    <th class="header-signals-activity">DATE</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let s of signals">
                    <td class="ps-3 fw-medium">{{ s.title }}</td>
                    <td>
                      <span class="text-primary" style="font-size: 0.65rem">{{
                        s.to
                      }}</span>
                    </td>
                    <td>
                      <span
                        [ngClass]="
                          s.status === 'Sent' ? 'text-success' : 'text-warning'
                        "
                        class="fw-medium"
                        >{{ s.status }}</span
                      >
                    </td>
                    <td class="text-muted">{{ s.date }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-4">
        <!-- <div class="col-12 d-flex">
          <div class="row row-cols-1 row-cols-md-3 g-3"> -->
        <!-- High-Value Keywords -->
        <div class="col-6 d-flex">
          <div class="card shadow-sm h-100 mt-4 flex-grow-1">
            <div class="card-header bg-white border-bottom-0 pb-0">
              <h4 class="fw-bold text-uppercase small mb-3">
                <strong>HIGH-VALUE KEYWORDS NOT MAPPED</strong>
                <i class="fas fa-info-circle text-muted ms-1"></i>
              </h4>
            </div>
            <div class="card-body p-0 custom-scroll-x">
              <table class="table table-sm table-borderless small mb-0">
                <thead class="text-uppercase">
                  <tr>
                    <th class="ps-3 head-table">
                      <strong>KEYWORD / CLUSTER</strong>
                    </th>
                    <th class="head-table">
                      <strong>OPPORTUNITY SCORE</strong>
                    </th>
                    <th class="head-table">
                      <strong>SEARCH INTENT</strong>
                    </th>
                    <th class="head-table">
                      <strong>ACTION</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let hw of highValueKeywords">
                    <td
                      class="ps-3 fw-medium text-truncate"
                      style="max-width: 120px"
                      title="{{ hw.keyword }}"
                    >
                      {{ hw.keyword }}
                    </td>
                    <td class="text-center">{{ hw.oppScore }}</td>
                    <td>
                      <span
                        class="text-dark fw-medium"
                        style="font-size: 0.7rem"
                        >{{ hw.intent }}</span
                      >
                    </td>
                    <td>
                      <span
                        class="fw-medium"
                        [ngClass]="{
                          'text-danger': hw.action === 'Create New Url',
                          'text-success': hw.action === 'Review Architecture',
                        }"
                        style="font-size: 0.7rem"
                        >{{ hw.action }}</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="text-end p-2 border-top">
                <a href="#" class="small text-decoration-none text-primary"
                  >View all unmapped opportunities
                  <i class="fas fa-arrow-right"></i
                ></a>
              </div>
            </div>
          </div>
        </div>

        <!-- Cannibalization Issues -->
        <div class="col-6 d-flex pl-0">
          <div class="card shadow-sm h-100 mt-4 flex-grow-1">
            <div class="card-header bg-white border-bottom-0 pb-0">
              <h4 class="fw-bold text-uppercase small mb-3">
                <strong>CANNIBALIZATION ISSUES</strong>
                <i class="fas fa-info-circle text-muted ms-1"></i>
              </h4>
            </div>
            <div class="card-body p-0 custom-scroll-x">
              <table class="table table-sm table-borderless small mb-0">
                <thead class="text-uppercase">
                  <tr>
                    <th class="ps-3 head-table">
                      <strong>URL</strong>
                    </th>
                    <th class="head-table">
                      <strong>COMPETING URL</strong>
                    </th>
                    <th class="head-table">
                      <strong>KEYWORD OVERLAP</strong>
                    </th>
                    <th class="head-table"><strong>SEVERITY</strong></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let ci of cannibalizationIssuesList">
                    <td
                      class="ps-3 text-truncate"
                      style="max-width: 120px"
                      title="{{ ci.primaryUrl }}"
                    >
                      {{ ci.primaryUrl }}
                    </td>
                    <td class="text-center" title="{{ ci.competingUrl }}">
                      {{ ci.competingUrl }}
                    </td>
                    <td class="text-center">{{ ci.overlap }}</td>
                    <td>
                      <span
                        class="badge rounded-pill"
                        [ngClass]="{
                          'bg-danger-light text-danger': ci.severity === 'High',
                          'bg-warning-light text-warning':
                            ci.severity === 'Medium',
                          'bg-success-light text-success':
                            ci.severity === 'Low',
                        }"
                        >{{ ci.severity }}</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="text-end p-2 border-top">
                <a href="#" class="small text-decoration-none text-primary"
                  >View all issues <i class="fas fa-arrow-right"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-4">
        <!-- Orphan Pages -->
        <div class="col-6 d-flex">
          <div class="card shadow-sm h-100 mt-4 flex-grow-1">
            <div class="card-header bg-white border-bottom-0 pb-0">
              <h4 class="fw-bold text-uppercase small mb-3">
                <strong>ORPHAN PAGES</strong>
                <i class="fas fa-info-circle text-muted ms-1"></i>
              </h4>
            </div>
            <div class="card-body p-0 custom-scroll-x">
              <table class="table table-sm table-borderless small mb-0">
                <thead class="text-uppercase">
                  <tr>
                    <th class="ps-3 head-table"><strong>PAGE</strong></th>
                    <th class="head-table"><strong>IN INDEX</strong></th>
                    <th class="head-table"><strong>BACKLINKS</strong></th>
                    <th class="head-table"><strong>STATUS</strong></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let op of orphanPages">
                    <td
                      class="ps-3 text-truncate"
                      style="max-width: 100px"
                      title="{{ op.page }}"
                    >
                      {{ op.page }}
                    </td>
                    <td class="text-center">{{ op.inIndex }}</td>
                    <td class="text-center">{{ op.backlinks }}</td>
                    <td class="text-center">
                      <span
                        class="badge rounded-pill"
                        [ngClass]="{
                          'bg-danger-light text-danger': op.status === 'Orphan',
                          'bg-success-light text-success':
                            op.status === 'Indexed',
                        }"
                        >{{ op.status }}</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="text-end p-2 border-top">
                <a href="#" class="small text-decoration-none text-primary"
                  >View all orphan pages <i class="fas fa-arrow-right"></i
                ></a>
              </div>
            </div>
          </div>
        </div>

        <div class="col-6 d-flex pl-0">
          <!-- Recent Mapping Activity -->
          <div class="card shadow-sm h-100 mt-4 flex-grow-1">
            <div
              class="card-header bg-white border-bottom-0 pb-0 d-flex justify-content-between align-items-center"
            >
              <h4 class="fw-bold text-uppercase small mb-0">
                <strong>RECENT MAPPING ACTIVITY</strong>
              </h4>
              <a href="#" class="small text-decoration-none text-primary"
                >View all activity <i class="fas fa-arrow-right"></i
              ></a>
            </div>
            <div class="card-body p-2 mt-3 custom-scroll-x">
              <table class="table table-sm table-borderless small mb-0">
                <thead class="text-muted text-uppercase">
                  <tr>
                    <th class="ps-3 header-signals-activity">ACTION</th>
                    <th class="header-signals-activity">DETAILS</th>
                    <th class="header-signals-activity">BY</th>
                    <th class="header-signals-activity">DATE</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let a of recentActivity" class="border-bottom">
                    <td class="ps-3 text-nowrap fw-medium">{{ a.action }}</td>
                    <td class="text-muted" style="font-size: 0.75rem">
                      {{ a.details }}
                    </td>
                    <td class="text-center">{{ a.by }}</td>
                    <td class="text-muted text-nowrap">{{ a.date }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 d-flex">
          <!-- Mapping Decision Center -->
          <div class="card shadow-sm flex-grow-1">
            <div class="card-header bg-white border-bottom-0 pb-0 pl-3">
              <h4 class="fw-bold text-uppercase small mb-3">
                <strong>MAPPING DECISION CENTER</strong>
                <i class="fas fa-info-circle text-muted ms-1"></i>
              </h4>
            </div>
            <div class="card-body container-fluid p-0">
              <div class="custom-scroll-x pb-2">
                <div
                  class="row align-items-stretch flex-nowrap mx-0"
                  style="min-width: 900px"
                >
                  <div class="col-5 pt-3">
                    <div class="mb-3 d-flex align-items-center">
                      <label
                        class="form-label small fw-bold mb-0 me-3 text-dark font-size9"
                        style="min-width: 140px"
                        ><strong>CURRENT MAPPING</strong></label
                      >
                      <div
                        class="d-flex align-items-center bg-light px-2 py-1 rounded w-100"
                      >
                        <span class="text-primary me-2 fw-medium font-size10">{{
                          selectedMapping.tags[1] || selectedMapping.status
                        }}</span>
                        <i class="fas fa-arrow-right text-muted small me-2"></i>
                        <span class="font-size10">{{
                          selectedMapping.primaryUrlCandidate
                        }}</span>
                      </div>
                    </div>
                    <div class="mb-3 d-flex align-items-center">
                      <label
                        class="form-label small fw-bold mb-0 me-3 text-dark font-size9"
                        style="min-width: 140px"
                        ><strong>DECISION URL</strong></label
                      >
                      <input
                        type="text"
                        class="form-control form-control-sm bg-white"
                        [(ngModel)]="decisionUrl"
                        placeholder="/assigned/url"
                      />
                    </div>
                    <div>
                      <label
                        class="form-label small fw-bold mb-1 text-dark font-size9"
                        ><strong>NOTES (Optional)</strong></label
                      >
                      <textarea
                        class="form-control form-control-sm bg-white"
                        rows="2"
                        [(ngModel)]="decisionNote"
                        placeholder="Add internal note..."
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div
                  class="row align-items-stretch flex-nowrap mx-0"
                  style="min-width: 900px"
                >
                  <div class="col-12 border-start border-end px-3">
                    <div
                      class="card border-0 bg-light py-3 px-0 mt-0 mb-0 shadow-none h-100"
                      style="margin-top: 0 !important"
                    >
                      <div class="row align-items-stretch h-100">
                        <div class="col-5">
                          <h6 class="small fw-bold text-primary mb-2">
                            <strong>AI RECOMMENDATION</strong>
                          </h6>
                          <div
                            class="d-flex justify-content-between mb-2 small"
                          >
                            <span class="text-dark">Recommended Role</span>
                            <span
                              class="text-primary fw-medium bg-primary-light px-2 rounded"
                              >Supporting</span
                            >
                          </div>
                          <p class="small mb-1 fw-bold text-dark">Reason</p>
                          <p class="small text-muted lh-sm mb-0">
                            Legal Services is best primary owner. This keyword
                            strengthens a specific use case within that intent.
                          </p>
                        </div>
                        <div class="col-7 border-start">
                          <div
                            class="d-flex justify-content-around align-items-start h-100"
                          >
                            <div class="text-center">
                              <h5
                                class="small fw-bold text-muted mb-2 text-center"
                              >
                                <strong>AI CONFIDENCE</strong>
                              </h5>
                              <div
                                class="progress-circle mx-auto"
                                data-perc="86"
                              >
                                <span class="text-success fw-bold fs-5"
                                  >86%</span
                                >
                                <span
                                  class="small text-success d-block"
                                  style="font-size: 0.65rem; margin-top: -5px"
                                  >High</span
                                >
                              </div>
                            </div>
                            <div class="text-center px-2">
                              <h5 class="small fw-bold text-muted mb-1">
                                <strong>RISK LEVEL</strong>
                              </h5>
                              <span
                                class="badge bg-success-light text-success d-inline-block mb-3"
                                >Low</span
                              >
                            </div>
                            <div class="text-center px-2">
                              <h5 class="small fw-bold text-muted mb-1">
                                <strong>EXECUTION MODE</strong>
                              </h5>
                              <span
                                class="badge bg-warning-light text-warning d-inline-block text-wrap"
                                style="max-width: 140px; line-height: 1.2"
                                >Human Approval Required</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="d-flex gap-3 justify-content-between mt-4 custom-scroll-x pb-2 flex-nowrap"
                style="min-width: 100%"
              >
                <div class="d-flex gap-2 flex-nowrap m-auto">
                  <button
                    class="btn btn-success btn-desicion-mapping"
                    [disabled]="saving"
                    (click)="approveMapping()"
                  >
                    <i class="fas fa-check me-2"></i> Approve Mapping
                  </button>
                  <button
                    class="btn btn-outline-secondary btn-desicion-mapping"
                  >
                    <i class="fas fa-pencil-alt me-2"></i> Edit Decision
                  </button>
                  <button
                    class="btn btn-outline-primary btn-desicion-mapping text-purple border-purple"
                  >
                    <i class="fas fa-robot me-2"></i> Ask AI to Reconsider
                  </button>
                  <button
                    class="btn btn-outline-danger btn-desicion-mapping"
                    [disabled]="saving"
                    (click)="rejectMapping()"
                  >
                    <i class="fas fa-times me-2"></i> Reject
                  </button>
                  <div class="dropdown">
                    <button
                      class="btn btn-outline-secondary dropdown-toggle btn-desicion-mapping"
                      type="button"
                      data-bs-toggle="dropdown"
                    >
                      <i class="fas fa-paper-plane me-2"></i> Create Signal
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="mt-3 text-muted small d-flex align-items-center">
        <i class="fas fa-info-circle me-2"></i> URL Mapping creates the
        architecture. Other modules execute and optimize within that
        architecture.
      </div> -->
    </div>

    <div
      *ngIf="loading"
      class="d-flex justify-content-center align-items-center"
      style="min-height: 400px"
    >
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
</div>
